"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ShowHideLined = function ShowHideLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.556 15.721l5.165-5.165a3.98 3.98 0 01-5.165 5.165zM7.827 16.88l.01.006-.746.745-.01-.006-3.228 3.229a.5.5 0 01-.707-.708L6.2 17.1a21.824 21.824 0 01-4.983-4.5.937.937 0 010-1.189C2.424 9.9 6.782 5 12 5a10.338 10.338 0 014.917 1.377l3.23-3.231a.5.5 0 01.707.708L17.81 6.9l.01.006-.732.731-.01-.005-1.93 1.928.007.008-5.588 5.587-.008-.007zm-.9-.515l1.926-1.925A3.927 3.927 0 018 12a3.982 3.982 0 012-3.445V12l3.64-3.64a3.828 3.828 0 01.8.492l1.731-1.731A9.16 9.16 0 0012 6c-4.9 0-9.2 5.026-10.009 6.033a22.115 22.115 0 004.937 4.332zm15.86-4.959a22.477 22.477 0 00-4.043-3.874l-.726.727A21.732 21.732 0 0121.983 12c-.877 1.081-5.139 6-9.983 6a8.493 8.493 0 01-3.089-.633l-.776.775A9.747 9.747 0 0012 19c5.218 0 9.576-4.9 10.787-6.4a.937.937 0 00.001-1.194z",
    fill: "currentColor"
  })));
};

var _default = ShowHideLined;
exports["default"] = _default;